import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import CommonImageUpload from '../../../Components/Common/CommonImageUpload';
import InputField from '../../../Components/Common/InputField';
import SelectField from '../../../Components/Common/SelectField';
import { useGetAllBankAccountList } from '../apiEndpoints/commonApiEndpoints';
import CommonCard from '../../../Components/Common/CommonCard';
import CommonFormBtn from '../../../Components/Common/CommonFormBtn';
import CommProfileHeader from '../../Exhibitor/Profile/CommProfileHeader';
import { useLocation, useNavigate } from 'react-router-dom';
import { decodeData } from '../../../Components/Common/utility/commonUtility';

const PaymentManagement = ({
  onChangeValue,
  navigateUrl,
  isSuccess,
  redirectUrl,
}: {
  onChangeValue?: (formValue: any) => Promise<void>; // Explicit async type
  navigateUrl?: string;
  redirectUrl?: string;
  isSuccess?: boolean;
}) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const value = searchParams?.get('value') || '';

  const navigate = useNavigate();
  const { data } = useGetAllBankAccountList();
  const {
    register,
    handleSubmit,
    clearErrors,
    setError,
    setValue,
    reset,
    resetField,
    watch,
    formState: { errors },
  } = useForm();

  const selectedBankName = watch('bank_name'); // Watch the bank_name field
  useEffect(() => {
    if (selectedBankName) {
      const selectedBankDetails = data?.data?.find(
        (item) => item.ac_bank_name === selectedBankName
      );
      if (selectedBankDetails) {
        setValue('bank_ac_no', selectedBankDetails.ac_number);
        setValue('branch_name', selectedBankDetails.ac_bank_branch);
      }
    }

    if (value) {
      setValue('amount', Number(decodeData(value)?.amount));
      setValue('payable_amount', Number(decodeData(value)?.amount));
      setValue('invoice_id', Number(decodeData(value)?.invoice_id));
    }
  }, [selectedBankName, setValue]);

  useEffect(() => {
    if (isSuccess) {
      reset();
      redirectUrl && navigate(redirectUrl);
    }
  }, [isSuccess]);

  const onSubmit = async (formValue: any) => {
    await onChangeValue?.(formValue);
  };

  return (
    <>
      <CommProfileHeader
        addHeadingTitle='Create Payment'
        toggle={true}
        setToggle={() => navigateUrl && navigate(navigateUrl)}
      />
      <CommonCard>
        <form
          className='form-horizontal'
          method='post'
          id='editProfile'
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className='row'>
            <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6'>
              <SelectField
                fieldName='bank_name'
                label='Bank Name'
                options={
                  data?.data?.map((item) => ({
                    label: item.ac_bank_name,
                    value: item.ac_bank_name,
                  })) || []
                }
                isRequired
                register={register}
              />
            </div>
            <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6'>
              <InputField
                label='Bank Account Number'
                register={register('bank_ac_no')}
                placeholder='Enter Bank Account Number'
                type='text'
                disabled
              />
            </div>
            <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6'>
              <InputField
                label='Branch Name'
                register={register('branch_name')}
                placeholder='Enter Branch Name'
                type='text'
                disabled
              />
            </div>
            <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6'>
              <InputField
                label='Deposit Date'
                register={register('deposit_date')}
                placeholder='Select Deposit Date'
                type='date'
                isRequired
              />
            </div>
            <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6'>
              <InputField
                label='Total Payable Amount'
                register={register('payable_amount')}
                placeholder='Enter Amount'
                type='number'
                disabled
              />
            </div>
            <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6'>
              <InputField
                label='Amount'
                register={register('amount')}
                placeholder='Enter Amount'
                type='number'
                isRequired
                disabled={decodeData(value)?.isVisitor}
              />
            </div>
          </div>
          <div className='row mt-2'>
            <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6'>
              <CommonImageUpload
                register={register}
                setError={setError}
                clearErrors={clearErrors}
                setValue={setValue}
                resetField={resetField}
                errors={errors}
                required
                label='Bank Slip'
                fileName='bank_slip'
                uploadBtnName='Upload Bank Slip'
                offLabel
              />
            </div>
          </div>
          <CommonFormBtn loading={isSuccess} />
        </form>
      </CommonCard>
    </>
  );
};

export default PaymentManagement;
